import {DateInput3} from "@blueprintjs/datetime2";
import styled from "@emotion/styled";
import {COLORS} from "../../../constants/constants";

const DateInput = styled(DateInput3)<{isValid?: boolean}>`
  font-family: Roboto, sans-serif;
  input {
    border: ${(props) => (props.isValid ? "solid 1px #dedede !important" : "solid 1px #cd4246 !important")};
    box-shadow: none;
    border-radius: 4px;
    height: 32px;

    ::placeholder {
      color: ${COLORS.COLOR_PLACE_HOLDER};
    }
  }

  .bp5-divider {
    display: none;
  }

  .DayPicker-Day--selected {
    background-color: #8da4be !important;
    border-radius: 4px !important;
  }

  .bp5-datepicker-day-wrapper {
    font-size: 14px;
    font-weight: 400;
    padding: 0;
    box-shadow: none;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none !important;
  }

  .DayPicker-Weekdays {
    font-size: 15px;
    font-weight: 500;

    .DayPicker-Weekday {
      padding: 0;
      height: 40px;
      font-size: 15px;
      font-weight: 500;
    }
  }

  .DayPicker-Caption {
    .bp5-datepicker-caption {
      justify-content: center;

      > * {
        flex-grow: 0 !important;
      }
      align-items: center;
      .bp5-html-select {
        select {
          padding: 4px !important;
          font-size: 16px;
          font-weight: 500;
        }
        option {
          padding: 5px !important;
        }
      }

      .bp5-icon-double-caret-vertical {
        display: none;
      }
    }
  }
`;

export default DateInput;
